import request, { IWorkspaceResponse } from "/@/api/http/request";

// 获取垃圾点位文件夹列表
export const getMapPointFolders = async function (
  workspaceId: string
): Promise<IWorkspaceResponse<any>> {
  const url = `MapPointFolder/all?workspaceId=${workspaceId}`;
  const result = await request.get(url);
  return result.data;
};

// 新增文件夹
export const saveMapPointFolderApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `MapPointFolder/save`;
  const result = await request.post(url, body);
  return result.data;
};

// 修改文件夹
export const updateMapPointFolderApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `MapPointFolder/update`;
  const result = await request.post(url, body);
  return result.data;
};

// 删除文件夹
export const deleteMapPointFolderApi = async function (
  id: number | string
): Promise<IWorkspaceResponse<any>> {
  const url = `MapPointFolder/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};

// 获取垃圾点位列表
export const getMapPointList = async function (
  workspaceId: string,
  folderId: string | number,
  page: number = 1,
  pageSize: number = 10,
  keyWord: string = "",
  type: string = "",
  sn: string = ""
): Promise<IWorkspaceResponse<any>> {
  let url = `MapPoint/page?workspaceId=${workspaceId}&folderId=${folderId}&current=${page}&size=${pageSize}&keyWord=${keyWord}`;
  if (type) {
    url += `&type=${type}`;
  }
  if (sn) {
    url += `&sn=${sn}`;
  }
  const result = await request.get(url);
  return result.data;
};

// 根据机场SN获取点位列表
export const getMapPointListBySn = async function (
  workspaceId: string,
  sn: string
): Promise<IWorkspaceResponse<any>> {
  const url = `MapPoint/list?workspaceId=${workspaceId}&sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};

// 新增垃圾点位
export const saveMapPointApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `MapPoint/save`;
  const result = await request.post(url, body);
  return result.data;
};

// 修改垃圾点位
export const updateMapPointApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `MapPoint/update`;
  const result = await request.post(url, body);
  return result.data;
};

// 删除垃圾点位
export const deleteMapPointApi = async function (
  id: number | string
): Promise<IWorkspaceResponse<any>> {
  const url = `MapPoint/delete?ids=${id}`;
  const result = await request.get(url);
  return result.data;
};

// 导入CSV
export const uploadMapPointCsvApi = async function (
  file: File,
  workspace: string,
  type: string
): Promise<IWorkspaceResponse<any>> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("workspace", workspace);
  formData.append("type", type);
  const url = `MapPoint/upload-csv`;
  const result = await request.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return result.data;
};

// ==================== 报告模块管理接口 ====================

// 获取报告模块列表
export const getReportModeListApi = async function (
  workspace: string
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportMode/getListAll?workspace=${workspace}`;
  const result = await request.get(url);
  return result.data;
};

// 新增报告模块
export const saveReportModeApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportMode/save`;
  const result = await request.post(url, body);
  return result.data;
};

// 修改报告模块
export const updateReportModeApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportMode/update`;
  const result = await request.post(url, body);
  return result.data;
};

// 删除报告模块
export const deleteReportModeApi = async function (
  id: number | string
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportMode/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};

// ==================== 报告模板配置接口 ====================

// 获取报告模板配置列表（分页）
export const getReportTemplatePageApi = async function (
  params: {
    current: number;
    size: number;
    workspace: string;
    name?: string;
  }
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportTemplate/page?current=${params.current}&size=${params.size}&workspace=${params.workspace}&name=${params.name || ''}`;
  const result = await request.get(url);
  return result.data;
};

// 新增报告模板配置
export const saveReportTemplateApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportTemplate/save`;
  const result = await request.post(url, body);
  return result.data;
};

// 修改报告模板配置
export const updateReportTemplateApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportTemplate/update`;
  const result = await request.post(url, body);
  return result.data;
};

// 删除报告模板配置
export const deleteReportTemplateApi = async function (
  id: number | string
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportTemplate/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};

// 获取报告模板配置详情
export const getReportTemplateByIdApi = async function (
  id: number | string
): Promise<IWorkspaceResponse<any>> {
  const url = `ReportTemplate/findById?id=${id}`;
  const result = await request.get(url);
  return result.data;
};

// 获取共享站点数据
export const getWebAllShareNewApi = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `workspaces/findWebAllShareNew?msTypeId=&msTypeIdExclusive=`;
  const result = await request.get(url);
  return result.data;
};
// 获取5分钟站点数据
export const getSiteAirQualityReportApi = async function (body:any): Promise<IWorkspaceResponse<any>> {
  const url = `workspaces/airMonitoring/getSiteAirQualityReport`;
  const result = await request.post(url,body);
  return result.data;
};

// 获取走航数据
export const getSailingDataApi = async function (
  params: {
    startTime: string;
    endTime: string;
    cellSize?: number;
    sample?: number;
  }
): Promise<IWorkspaceResponse<any>> {
  const { startTime, endTime, cellSize = 2, sample = 1 } = params;
  const url = `workspaces/lxSailing/list/data/new?startTime=${startTime}&endTime=${endTime}&cellSize=${cellSize}&sample=${sample}`;
  const result = await request.get(url);
  return result.data;
};
